import { isManagerRole, isOwnerRole, normalizeRole } from './userLocale';

/**
 * Pages staff and managers must not open — owner-level only.
 * Managers may open reports and stock approvals for their branch.
 */
const OWNER_ONLY_PAGES = new Set([
  'printing-rates',
  'cash-insights',
  'cash-sms-monitor',
  'reports',
  'report-daily',
  'report-weekly',
  'report-monthly',
  'report-printing',
  'report-stock',
  'report-wakala',
  'report-loan-pack',
  'security-logs',
  'security-tips',
  'settings',
  'settings-notifications',
  'settings-account',
  'business-settings',
  'subscription',
  'subscription-checkout',
  'stock-pending',
  'branches-list',
  'users-add',
]);

const MANAGER_ALLOWED_PAGES = new Set([
  'reports',
  'report-daily',
  'report-weekly',
  'report-monthly',
  'report-printing',
  'report-stock',
  'report-wakala',
  'report-loan-pack',
  'stock-pending',
]);

const EXPENSE_PAGES = new Set([
  'expenses',
  'expenses-summary',
  'expenses-add',
  'expenses-boss-history',
  'expenses-employee-history',
  'expenses-office-history',
]);

const EMPLOYEE_BLOCKED_PAGES = new Set([]);

export function isStaffEmployee(role) {
  return normalizeRole(role) === 'employee';
}

const STAFF_SETTINGS_PAGES = new Set([
  'settings',
  'business-settings',
  'settings-notifications',
  'settings-appearance',
  'settings-account',
  'settings-modules',
]);

export function isStaffSettingsPage(pageKey) {
  return STAFF_SETTINGS_PAGES.has(pageKey);
}

export function employeeMayAccessPage(pageKey, role) {
  if (isOwnerRole(role)) return true;
  if (EXPENSE_PAGES.has(pageKey) && isStaffEmployee(role)) return false;
  if (isManagerRole(role) && MANAGER_ALLOWED_PAGES.has(pageKey)) return true;
  if (OWNER_ONLY_PAGES.has(pageKey)) return false;
  if (!isStaffEmployee(role)) return true;
  return !EMPLOYEE_BLOCKED_PAGES.has(pageKey);
}
